var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("공지사항")])]), !_vm.$route.params._notification ? _c('notification-list') : _c('notification-view')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }